import React from "react";

interface Props extends React.SVGProps<SVGSVGElement> {
  className?: string;
}

const SendToProd: React.FC<Props> = ({ className, ...props }) => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1360.000000 1124.000000"
      preserveAspectRatio="xMidYMid meet"
      className={className}
      {...props}
    >
      <g
        transform="translate(0.000000,1124.000000) scale(0.100000,-0.100000)"
        fill="#000000"
        stroke="none"
      >
        <path
          d="M7005 11230 c-364 -4 -538 -9 -556 -17 -15 -6 -43 -26 -63 -44 -120
-105 -94 -294 49 -360 37 -17 73 -19 480 -19 l439 0 -411 -412 c-288 -289
-417 -425 -428 -452 -61 -145 45 -306 200 -306 97 0 111 12 546 446 l406 406
6 -39 c4 -21 7 -224 7 -452 0 -281 4 -426 11 -452 26 -84 113 -149 201 -149
88 0 153 37 196 110 l27 45 3 350 c4 535 -12 1233 -28 1268 -8 17 -35 40 -64
55 -51 27 -53 27 -271 28 -121 0 -458 -2 -750 -6z"
        />
        <path
          d="M11555 9619 c-373 -4 -697 -10 -718 -13 -54 -9 -130 -49 -173 -93
-91 -90 -118 -247 -62 -365 31 -66 91 -128 156 -160 l47 -23 820 3 820 2
-1151 -1152 c-928 -929 -1156 -1163 -1175 -1203 -35 -73 -35 -209 1 -280 73
-151 249 -223 410 -170 67 22 53 9 1432 1384 l967 965 3 -829 c4 -947 -3 -880
94 -984 73 -79 133 -105 239 -105 60 1 92 6 127 22 63 28 134 95 166 157 l27
50 -1 1265 c-1 1470 9 1342 -102 1450 -45 44 -80 70 -108 78 -46 14 -649 14
-1819 1z"
        />
        <path
          d="M3925 8643 c-167 -25 -315 -107 -423 -236 -52 -63 -116 -192 -131
-265 -6 -30 -11 -161 -11 -300 l0 -247 -114 -39 c-63 -21 -172 -62 -242 -92
l-129 -54 -200 199 c-278 276 -350 318 -565 328 -160 8 -283 -29 -412 -123
-25 -19 -199 -191 -385 -382 -292 -299 -343 -357 -376 -419 -99 -190 -101
-400 -5 -599 27 -56 61 -99 188 -229 85 -88 169 -176 187 -195 l32 -35 -46
-95 c-26 -52 -73 -156 -104 -230 l-57 -135 -299 -6 c-333 -6 -373 -12 -498
-77 -102 -53 -211 -166 -264 -274 -70 -142 -72 -164 -69 -737 l3 -506 28 -81
c33 -99 85 -180 165 -259 74 -72 145 -117 244 -153 70 -25 83 -27 341 -32
l268 -5 33 -100 c18 -55 58 -163 89 -240 l57 -140 -208 -210 c-133 -135 -219
-231 -241 -268 -53 -90 -81 -201 -81 -316 0 -116 17 -190 68 -291 33 -67 69
-108 355 -402 175 -180 339 -345 364 -368 113 -100 257 -158 408 -167 115 -6
206 12 321 66 82 39 99 53 278 229 l191 189 115 -58 c63 -31 168 -79 232 -106
l116 -48 4 -305 c4 -300 4 -306 31 -386 64 -193 217 -346 411 -412 l81 -27
520 0 c517 0 520 0 595 23 116 37 203 87 279 163 82 81 130 157 167 264 27 77
28 89 33 344 l6 264 125 42 c69 23 176 63 239 89 l113 47 217 -213 c237 -234
276 -262 417 -298 87 -22 222 -26 306 -9 29 6 91 29 138 51 82 40 95 51 425
377 187 185 357 356 378 381 48 57 102 166 123 250 20 76 22 233 5 300 -43
162 -99 245 -304 449 l-165 163 56 117 c30 64 77 168 103 231 l48 115 303 6
c337 6 366 11 492 77 86 45 209 162 253 242 17 30 41 84 54 120 24 65 24 67
27 580 3 581 2 593 -69 741 -57 117 -169 227 -289 286 -47 22 -107 46 -135 53
-29 7 -159 15 -309 19 l-258 6 -34 104 c-19 57 -59 164 -90 238 l-56 135 200
202 c213 214 269 286 303 395 30 92 37 255 15 341 -21 84 -75 193 -124 250
-21 25 -188 194 -372 375 -278 274 -346 336 -400 365 -36 18 -69 39 -75 46
-33 41 -270 63 -385 35 -70 -17 -166 -60 -225 -101 -26 -18 -123 -107 -216
-198 l-170 -165 -137 66 c-75 37 -180 84 -232 106 l-95 40 -5 313 c-5 286 -8
319 -28 378 -29 88 -82 173 -150 243 -77 78 -149 125 -252 161 l-85 31 -500 1
c-275 1 -513 0 -530 -3z m994 -540 c29 -26 45 -50 51 -78 5 -22 10 -200 10
-396 l0 -355 26 -53 c36 -72 77 -98 240 -156 151 -54 401 -172 547 -259 136
-81 202 -90 302 -39 17 9 143 128 281 264 263 262 256 256 339 250 16 -2 47
-16 70 -31 63 -44 623 -612 635 -643 5 -16 10 -45 10 -64 0 -34 -17 -53 -275
-313 -300 -302 -316 -324 -316 -426 0 -48 9 -74 69 -197 83 -170 158 -366 206
-541 45 -163 71 -206 151 -249 38 -21 55 -22 407 -27 351 -5 368 -6 394 -26
15 -11 37 -33 48 -48 21 -27 21 -38 21 -496 0 -458 0 -469 -21 -496 -11 -15
-33 -37 -48 -48 -26 -20 -43 -21 -419 -26 -358 -5 -395 -7 -430 -24 -65 -32
-101 -85 -147 -219 -56 -161 -106 -273 -192 -431 -127 -233 -136 -250 -142
-289 -5 -24 -1 -59 9 -95 16 -54 28 -69 265 -307 136 -137 253 -260 259 -272
19 -37 13 -114 -12 -153 -37 -59 -621 -628 -660 -645 -43 -18 -80 -19 -110 -4
-12 6 -146 134 -297 284 -300 298 -304 301 -409 293 -45 -3 -90 -20 -217 -80
-192 -91 -342 -147 -506 -189 -135 -34 -194 -62 -232 -112 -50 -65 -51 -70
-56 -460 l-5 -368 -41 -39 c-34 -31 -51 -39 -95 -45 -30 -3 -241 -5 -469 -3
-411 3 -415 3 -451 26 -68 42 -69 47 -69 449 0 390 -3 419 -54 486 -33 43 -89
72 -271 138 -150 55 -344 148 -490 235 -51 31 -111 58 -138 63 -52 9 -121 0
-165 -23 -15 -8 -130 -118 -255 -245 -124 -127 -241 -240 -259 -251 -38 -23
-104 -26 -151 -7 -37 16 -645 629 -658 665 -5 13 -9 43 -9 67 l0 43 271 268
c151 150 280 287 292 309 15 28 21 59 22 105 0 61 -5 76 -77 230 -108 231
-164 386 -209 575 -23 95 -70 159 -149 201 -32 17 -69 19 -400 24 -400 5 -394
4 -437 68 -17 25 -18 61 -21 474 -2 296 1 461 8 488 7 26 23 49 47 67 l36 28
391 5 c428 5 420 4 489 69 38 34 47 53 102 206 56 157 150 354 247 523 62 108
72 132 76 184 8 109 -2 124 -279 403 -158 160 -250 261 -255 279 -3 15 -4 47
-1 72 4 42 16 56 303 350 165 169 317 320 338 336 32 23 49 28 94 28 l55 0
281 -279 c272 -270 284 -280 340 -296 38 -11 73 -15 100 -11 22 4 113 42 201
85 188 93 336 148 505 191 143 36 162 45 211 97 66 69 64 54 69 453 6 404 6
406 72 449 32 20 42 21 499 21 l466 0 42 -37z"
        />
        <path
          d="M4175 6180 c-207 -15 -387 -58 -592 -142 -834 -342 -1302 -1276
-1082 -2159 120 -483 423 -898 840 -1147 550 -330 1201 -360 1776 -83 742 358
1162 1174 1023 1983 -88 512 -383 970 -801 1242 -352 228 -755 334 -1164 306z
m376 -506 c112 -18 231 -55 348 -110 395 -185 669 -536 762 -977 17 -81 22
-137 22 -267 0 -252 -40 -418 -155 -641 -191 -373 -529 -625 -953 -714 -112
-23 -311 -30 -428 -16 -371 47 -718 244 -933 531 -78 103 -184 308 -218 422
-46 152 -60 251 -59 423 0 232 44 418 145 620 187 371 540 640 953 725 136 28
358 30 516 4z"
        />
      </g>
    </svg>
  );
};

export default SendToProd;
